import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import {
    LOADING,
    COMPLETE,
    SIGNATURES_GET_SINGLE_OK,
    SIGNATURES_GET_ALL_OK,
    SIGNATURES_GET_PREFERENCES_OK,
    SIGNATURES_SET_PREFERENCES_OK,
    SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY
} from './types';
import { call } from '../utilities/http';
import store from '../configuration/store';
import { getUserProfile, updateUserProfile } from './identity';
import { getFullName } from '../utilities/string';

const defaultState = {
    preferences: undefined,
    list: undefined,
    dialogVisible: false,
    dialogPostAction: undefined
};

/**
 * Signatures state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case SIGNATURES_GET_SINGLE_OK:
            return { ...state, list: state.list ? [...state.list, action.data] : [action.data] };

        case SIGNATURES_GET_PREFERENCES_OK:
        case SIGNATURES_SET_PREFERENCES_OK:
            return { ...state, preferences: action.data };

        case SIGNATURES_GET_ALL_OK:
            return { ...state, list: action.data };

        case SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY:
            return { ...state, dialogVisible: action.data, dialogPostAction: action.data === true ? action.postAction : undefined };

        default:
            return state;
    }
}

export function setPreferencesDialogVisibility(visible) {
    return async function(dispatch) {
        dispatch({ type: SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY, data: visible });
    };
}

export function getSignaturePreferences(userId, onSuccess = response => null) {
    const { profile } = store.getState().identity;

    return async function(dispatch) {
        if (profile) {
            const { esig_name, esig_font } = profile;
            dispatch({ type: SIGNATURES_GET_PREFERENCES_OK, data: { esig_font, esig_name } });
            onSuccess({ esig_font, esig_name });
            return;
        }

        getUserProfile(userId, result => {
            const { esig_name, esig_font } = result;
            dispatch({ type: SIGNATURES_GET_PREFERENCES_OK, data: { esig_font, esig_name } });
            onSuccess({ esig_font, esig_name });
        })(dispatch);
    };
}

export function setSignaturePreferences(preferences, onSuccess = response => null) {
    const { profile } = store.getState().identity;
    let signature = {
        esig_font: preferences && preferences.esig_font ? preferences.esig_font : '1',
        esig_name: getFullName(profile)
    };

    return async function(dispatch) {
        updateUserProfile({ ...profile, ...signature }, () => {
            dispatch({ type: SIGNATURES_SET_PREFERENCES_OK, data: signature });
            onSuccess(signature);
        })(dispatch);
    };
}

export function getSignatures(role, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getSignatures'} defaultMessage={'Unable to retrieve user signatures.'} />;
    const { id, type } = role;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/esign?ref_type=${type}&ref_id=${id}` })
            .then(response => {
                dispatch({ type: SIGNATURES_GET_ALL_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getSignature(signatureId, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getSignature'} defaultMessage={'Unable to retrieve user signature.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/esign/${signatureId}` })
            .then(response => {
                dispatch({ type: SIGNATURES_GET_SINGLE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function sign(role, signatureKey, onSuccess = (response, dispatch) => null, includePreferences = true) {
    let errorMessage = <FormattedMessage id={'error.signature'} defaultMessage={'Error occurred while persisting signature.'} />;
    const { id, type } = role;
    let data = {
        name: signatureKey,
        ref_id: id,
        ref_type: type
    };

    const { profile } = store.getState().identity;
    const { esig_name, esig_font } = profile;

    if (includePreferences && (!esig_name || !esig_font)) {
        return async function(dispatch) {
            dispatch({
                type: SIGNATURES_SET_PREFERENCES_DIALOG_VISIBILITY,
                data: true,
                postAction: () => sign(role, signatureKey, onSuccess, false)(dispatch)
            });
        };
    } else {
        return async function(dispatch) {
            dispatch({ type: LOADING });
            call({ path: '/esign', method: 'POST', body: data })
                .then(response => {
                    getSignature(response.id)(dispatch);
                    dispatch({ type: COMPLETE });
                    onSuccess(response, dispatch);
                })
                .catch(error => {
                    Snackbar.error(errorMessage);
                    dispatch({ type: COMPLETE });
                });
        };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/signatures.jsx